<script>
import Layout from '../../layout/Layout'
import DefaultMixin from '../mixin'

export default {
  name: 'Comitentes',
  mixins: [DefaultMixin],
  components: {
    Layout
  },
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
  },
  meta: {
    title: 'Mapfre - Boletos',
    name: 'Mapfre - Boletos'
  }
}
</script>

<template>
  <layout class="erp-list" no-menu menu-style="compact" menu-active="comitentes">
    <div class="erp-list">
      <iframe
          :src="'https://api-sc3.suporteleiloes.com.br/api/public/mapfre/adm/home?usu=' + this.$uloc?.auth?.session?.user?.username ?? ''"
          width="100%"
          height="800"
          style="border:1px solid #ccc;"
          loading="lazy"></iframe>
    </div>
  </layout>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
